<template>
  <div class="report-page-wrapper">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#9a6b27"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <div class="d-flex align-center justify-space-between text-white" style="font-size: 13px;">
        <span>{{ msg }}</span>
        <v-btn small icon text @click="showsnackbar = false" class="ml-2">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <!-- Top Executive Header Card -->
    <v-card flat class="header-card pa-4 mb-4 rounded-lg">
      <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 16px;">
        <div class="d-flex align-center">
          <div class="header-icon-box mr-3">
            <v-icon color="#0f172a" size="22">mdi-currency-inr</v-icon>
          </div>
          <div>
            <div class="page-title">BOARDING RATE</div>
            <div class="page-subtitle">Set daily metal rates used across billing, purchase &amp; valuation</div>
          </div>
        </div>

        <div class="d-flex flex-wrap align-center" style="gap: 10px;">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newdate"
                label="Date"
                outlined
                background-color="white"
                readonly
                hide-details
                dense
                class="pro-input date-input"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="newdate"
              no-title
              color="#9a6b27"
              @input="(menu2 = false); getBording();"
            ></v-date-picker>
          </v-menu>

          <v-btn
            dark
            color="#9a6b27"
            class="btn-primary text-capitalize elevation-1"
            @click="EditRate()"
          >
            <v-icon left small>mdi-content-save-outline</v-icon>
            Save
          </v-btn>
        </div>
      </div>
    </v-card>

    <!-- Rate Cards Grid -->
    <div class="rate-grid">
      <div class="rate-card" v-for="metal in metals" :key="metal.key">
        <div class="rate-card-header">
          <div class="rate-img-pill">
            <img :src="metal.img" :alt="metal.label" class="rate-img" />
          </div>
          <div class="rate-label">{{ metal.label }}</div>
        </div>
        <v-text-field
          :value="$data[metal.key]"
          @input="$data[metal.key] = $event"
          placeholder="0"
          type="number"
          outlined
          dense
          hide-details
          prefix="₹"
          class="rate-input"
        ></v-text-field>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      page: 1,
      Pagelength: null,
      goldrate: 0,
      thankamrate: 0,
      silverrate: 0,
      platinumrate: 0,
      diamondrate: 0,
      menu2: false,

      thankam: 0,
      gold: 0,
      silver: 0,
      platinum: 0,
      diamond: 0,
      rate18ct: 0,

      newdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dataList: {},

      metals: [
        { key: "thankam", label: "Thankam Per gm", img: require("../../assets/icons/rate_thankam.jpg") },
        { key: "gold", label: "Gold Per gm", img: require("../../assets/icons/rate_gold.jpg") },
        { key: "silver", label: "Silver Per gm", img: require("../../assets/icons/rate_silver.jpg") },
        { key: "platinum", label: "Platinum Per gm", img: require("../../assets/icons/rate_platinum.jpg") },
        { key: "diamond", label: "Diamond", img: require("../../assets/icons/rate_diamond.jpg") },
        { key: "rate18ct", label: "18-CT Gold Per gm", img: require("../../assets/icons/rate_18ct.jpg") },
      ],
    };
  },
  mounted() {
    this.newdate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10);
    if (this.newdate) {
      this.getBording();
    }
  },
  methods: {
    EditRate() {
      axios({
        url: "/rate/add",
        method: "POST",
        data: {
          goldRate: this.gold,
          silverRate: this.silver,
          platinumRate: this.platinum,
          diamond: this.diamond,
          date: this.newdate,
          thankamRate: this.thankam,
          rate18ct: this.rate18ct,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getBording();
            this.goldrate = null;
            this.silverrate = null;
            this.platinumrate = null;
            this.diamondrate = null;
            this.date = null;
            location.reload();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getBording() {
      this.appLoading = true;
      axios({
        url: "/rate/view",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.newdate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.dataList = response.data.data;
          this.thankam = response.data.data.thankamRate;
          this.gold = response.data.data.goldRate;
          this.silver = response.data.data.silverRate;
          this.platinum = response.data.data.platinumRate;
          this.diamond = response.data.data.diamond;
          this.rate18ct = response.data.data.rate18ct;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap");

.report-page-wrapper {
  padding: 4px 0 40px 0;
  width: 100%;
  margin: 0 auto;
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #0f172a;
}

.header-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

.header-icon-box {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.page-subtitle {
  font-size: 12px;
  color: #64748b;
  margin-top: 1px;
}

.date-input {
  width: 160px;
}

.pro-input :deep(.v-input__slot) {
  min-height: 38px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
}

.pro-input :deep(fieldset) {
  border-color: #cbd5e1 !important;
}

.pro-input.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
  border-width: 1.5px !important;
}

.btn-primary {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  height: 38px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.2s ease !important;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px);
}

.btn-secondary {
  background-color: #0f172a !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  height: 38px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.btn-secondary:hover {
  background-color: #1e293b !important;
  transform: translateY(-1.5px);
}

/* Rate Cards Grid */
.rate-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

@media (max-width: 960px) {
  .rate-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .rate-grid {
    grid-template-columns: 1fr;
  }
}

.rate-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
}

.rate-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.rate-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.rate-img-pill {
  width: 40px;
  height: 40px;
  border-radius: 9px;
  background-color: #ffffff;
  border: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.rate-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.rate-label {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  letter-spacing: 0.2px;
}

.rate-input :deep(.v-input__slot) {
  border-radius: 8px !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.rate-input :deep(fieldset) {
  border-color: #e2e8f0 !important;
}

.rate-input.v-input--is-focused :deep(fieldset) {
  border-color: #9a6b27 !important;
  border-width: 1.5px !important;
}

.rate-input :deep(input) {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.rate-input :deep(.v-text-field__prefix) {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #64748b !important;
}
</style>
